<template>
    <div>
        <app-layout>
            <template v-slot:header>
                <Header :title="$t('mentora_transfer_out_request')"
                        :isFilter="false"/>
            </template>
            <template v-slot:header-mobile>
                <HeaderMobile :title="$t('mentora_transfer_out_request')"
                              :isFilter="false"/>
            </template>
            <div class="row data-form">
                <div class="col-12">
                    <div class="mb-4">
                        <h6 class="text-uppercase mb-0">{{ $t('student_information').toUpper() }}</h6>
                    </div>
                </div>
                <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3">
                    <b-form-group :label="$t('sevis_id').toUpper()">{{ this.getObjectValue(leaveStudentData, 'sevis_id') }}</b-form-group>
                </div>
                <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3">
                    <b-form-group :label="$t('student_number_long')">{{ leaveStudentData.student_number }}</b-form-group>
                </div>
                <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3">
                    <b-form-group :label="$t('name_surname')">{{ leaveStudentData.name }} {{ leaveStudentData.surname }}</b-form-group>
                </div>

                <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3">
                    <b-form-group :label="$t('program')">{{ leaveStudentData.program_name }}</b-form-group>
                </div>
                <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3">
                    <b-form-group :label="$t('state')">{{ this.getObjectValue(leaveStudentData, 'contact_state_name') }}</b-form-group>
                </div>
                <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3">
                    <b-form-group :label="$t('district')">{{ this.getObjectValue(leaveStudentData, 'contact_city_name') }}</b-form-group>
                </div>
                <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3">
                    <b-form-group :label="$t('email')">{{ this.getObjectValue(leaveStudentData, 'email') }}</b-form-group>
                </div>
                <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3">
                    <b-form-group :label="$t('gsm_no')">{{this.getObjectValue(leaveStudentData, 'mobile_tel_country_code')}}{{ this.getObjectValue(leaveStudentData, 'mobile_tel') }}</b-form-group>
                </div>
                <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3">
                    <b-form-group :label="$t('address')">{{ this.getObjectValue(leaveStudentData, 'contact_address') }}</b-form-group>
                </div>

                <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3">
                    <b-form-group :label="$t('module')">{{ this.getObjectValue(leaveStudentData, 'module') }}</b-form-group>
                </div>

            </div>
            <hr>
            <div class="my-3 d-inline-block"></div>
            <div class="mb-4">
                <h6 class="text-uppercase mb-0">{{ $t('application_information').toUpper() }}</h6>
            </div>
            <ValidationObserver ref="leaveForm">
              <b-row>
                <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-3">
                        <ValidationProvider name="reason" rules="required" v-slot="{ valid, errors }">
                            <b-form-group :label="$t('reason_for_transferring_out')">
                                <b-form-radio-group
                                    v-model="form.reason"
                                    :options="reasonOptions"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    stacked
                                ></b-form-radio-group>
                            </b-form-group>
                        </ValidationProvider>
                    <ValidationProvider name="explanation" rules="required" v-slot="{valid, errors}">
                        <b-form-group :label="$t('explanation')">
                            <b-form-textarea v-model="form.explanation"
                                             :state="errors[0] ? false : null">
                            </b-form-textarea>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </div>
                <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-3">
<!--                        <ValidationProvider name="new_institution" rules="required" v-slot="{ errors }">
                            <b-form-group :label="$t('new_institution')">
                                <b-form-input v-model="form.new_institution" />
                                <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
                            </b-form-group>
                        </ValidationProvider>-->
                        <ValidationProvider name="new_institution_id " rules="required" v-slot="{valid, errors}">
                            <b-form-group :label="$t('new_institution')"  :description="$t('new_institution_description')">
                                <university-selectbox
                                    :validate-error="errors[0]"
                                    :state="errors[0] ? false : null"
                                    v-model="form.new_institution_id ">
                                </university-selectbox>
                            </b-form-group>
                        </ValidationProvider>
                        <ValidationProvider name="new_program_of_study" rules="required" v-slot="{ valid, errors }">
                            <b-form-group :label="$t('new_program_of_study')">
                                <parameter-selectbox v-model="form.new_program_of_study"
                                                     code="transfer_out_new_program_of_studies" :validate-error="errors[0]"/>
                            </b-form-group>
                        </ValidationProvider>
                        <ValidationProvider name="new_subject_of_study" rules="required" v-slot="{ valid, errors }">
                            <b-form-group :label="$t('new_subject_of_study')">
                                <parameter-selectbox v-model="form.new_subject_of_study"
                                                     code="transfer_out_new_subject_of_studies" :validate-error="errors[0]"/>
                            </b-form-group>
                        </ValidationProvider>
                        <ValidationProvider name="school_sevis_code" rules="required" v-slot="{ errors }">
                            <b-form-group :label="$t('new_sevis_school_code')">
                                <b-form-input v-model="form.school_sevis_code" />
                                <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
                            </b-form-group>
                        </ValidationProvider>
                </div>
                <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-3">
                        <ValidationProvider name="program_start_date" rules="required" v-slot="{ errors }">
                            <b-form-group :label="$t('starting_date_new_institution')">
                                <select-date v-model="form.program_start_date" :validation-error="errors[0]" />
                                <span class="ml-2 text-muted small">{{ new Date().toLocaleString() }}</span>
                            </b-form-group>
                        </ValidationProvider>
                        <ValidationProvider name="eligibility_file" rules="" v-slot="{errors}">
                            <b-form-group :label="$t('transfer_verification_form_new_institution')">
                                <div class="d-flex custom-file-upload">
                                    <b-form-file
                                        v-model="form.eligibility_file"
                                        :state="errors[0] ? false : null"
                                        :placeholder="$t('drop_file')"
                                        :drop-placeholder="$t('drop_file')"
                                        ref="fileInputEligibility"
                                        ></b-form-file>
                                    <b-button variant="outline-secondary" @click="$refs.fileInputEligibility.$el.childNodes[0].click();">{{ $t('browse') }}</b-button>
                                </div>
                                <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
                            </b-form-group>
                        </ValidationProvider>
                    </div>
                <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-3">
                        <ValidationProvider name="acceptance_letter_file" rules="required" v-slot="{errors}">
                            <b-form-group :label="$t('acceptance_letter_file')">
                                <div class="d-flex custom-file-upload">
                                    <b-form-file
                                        v-model="form.acceptance_letter_file"
                                        :state="errors[0] ? false : null"
                                        :placeholder="$t('acceptance_letter_file')"
                                        :drop-placeholder="$t('drop_file')"
                                        ref="fileInputAcceptanceLetter"
                                        ></b-form-file>
                                    <b-button variant="outline-secondary" @click="$refs.fileInputAcceptanceLetter.$el.childNodes[0].click();">{{ $t('browse') }}</b-button>
                                </div>
                                <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
                            </b-form-group>
                        </ValidationProvider>
                </div>
            </b-row>
            </ValidationObserver>
            <div class="d-flex justify-content-center">
                <b-form-group>
                    <b-button variant="primary" @click="save">{{ $t('save') }}</b-button>
                </b-form-group>
            </div>
            <CommonModal size="xl" ref="transferOutModal">
                <template v-slot:CommonModalTitle>
                </template>
                <template v-slot:CommonModalContent>
                    <div>
                       <TransferOutFormModal v-if="formProcess === 'transfer_out_form'" :student-data="leaveStudentData" :form="form" @formError="showErrorModal($event)"/>
                    </div>
                </template>
            </CommonModal>

        </app-layout>
    </div>
</template>
<script>
// Template
import AppLayout from '@/layouts/AppLayout';
import Header from '@/layouts/AppLayout/Header';
import HeaderMobile from '@/layouts/AppLayout/HeaderMobile';

import TransferOutRequestMentora from '@/services/TransferOutRequestMentora';

// Other
import {ValidationObserver, ValidationProvider} from 'vee-validate';
import TransferOutFormModal from "@/modules/transferOutFormMentora/pages/TransferOutFormModal.vue";
import UniversitySelectbox from "@/components/interactive-fields/UniversitySelectbox.vue";
import YesNoSelectbox from "@/components/interactive-fields/YesNoSelectbox.vue";
import ParameterSelectbox from "@/components/interactive-fields/ParameterSelectbox.vue";

export default {
    components: {
        YesNoSelectbox,
        ParameterSelectbox,
        UniversitySelectbox,
        TransferOutFormModal,
        AppLayout,
        Header,
        HeaderMobile,
        ValidationProvider,
        ValidationObserver
    },
    data() {
        return {
            form:{},
            formProcess:null,
            leaveStudentData:{},
            reasonOptions: [
                { value: 'Tuition Fee', text: 'Tuition Fee' },
                { value: 'Commute/Transportation/Housing Issue', text: 'Commute/Transportation/Housing Issue' },
                { value: 'Curriculum-Related', text: 'Curriculum-Related' },
                { value: 'Program of Study Needs (insterested in something else)', text: 'Program of Study Needs (insterested in something else)' },
                { value: 'Completed Program', text: 'Completed Program' },
            ],
        }
    },
    metaInfo() {
        return {
            title: this.$t('mentora_transfer_out_request')
        }
    },
    methods: {
        formClear(){

        },
        async getFormData() {
            try {
                const response = await TransferOutRequestMentora.getStudentForm()
                this.leaveStudentData=response.data.data
            }catch (error) {
                this.showErrors(error)
            }
        },
       async save(){
            if (!await this.$refs.leaveForm.validate()) return
            try {
                this.formProcess='transfer_out_form'
                this.$refs.transferOutModal.$refs.commonModal.show()
                // const res=await TransferOutRequestMentora.save(this.form)
                // this.$toast.success(this.$t(res.data.message))
            }catch (error){
                this.showErrors(error,this.$refs.leaveForm)
            }
        },
        showErrorModal(error){
            this.showErrors(error,this.$refs.leaveForm)
            this.$refs.transferOutModal.$refs.commonModal.hide()
        }
    },
    created() {
        this.getFormData()
    },
};
</script>
